import React, { useContext } from 'react';

/* packages */
import { Fetch } from '../../../lib-atomic-functions';
/* packages */

/* stores */
import Store from './store';
/* stores */

const index = ({CONFIG}) => {
  const contactCreateContext  = useContext(Store);
  const contactCreateMethod = async ({token, companyId, body}) => {
    contactCreateContext.setLoading({loading: true, status: true, data: false});
    CONFIG.application.contact.api.headers.Authorization = token;
    const fetch = await Fetch({
      url: CONFIG.application.contact.api.endpoints.create.url + companyId + '/contacts',
      config: {
        method: CONFIG.application.contact.api.endpoints.create.method,
        headers: CONFIG.application.contact.api.headers,
        body
      }
    });
    contactCreateContext.setLoading({loading: false, status: fetch[0], data: fetch[1]});
  }

  return { contactCreateContext, contactCreateMethod }
}

export default index;
